import React, { useEffect, useRef } from 'react';
import JsBarcode from 'jsbarcode';

export default function InvoiceBarcode({
  value,
  width = 1.4,
  height = 36,
  displayValue = false,
  fontSize = 11,
  margin = 0,
  format = 'CODE128',
  style,
  className,
}) {
  const svgRef = useRef(null);

  useEffect(() => {
    if (!svgRef.current || !value) return;
    try {
      JsBarcode(svgRef.current, String(value).trim(), {
        format,
        width,
        height,
        displayValue,
        fontSize,
        margin,
        textMargin: 2,
        background: 'transparent',
        lineColor: '#000000',
      });
    } catch (e) {
      console.warn('Could not generate barcode for value:', value, e);
    }
  }, [value, width, height, displayValue, fontSize, margin, format]);

  if (!value) return null;

  return (
    <svg
      ref={svgRef}
      style={{
        display: 'inline-block',
        verticalAlign: 'middle',
        maxWidth: '100%',
        ...style,
      }}
      className={className}
    />
  );
}
